import { todayISO } from "@/utils/datetime";

/**
 * Data de hoje "YYYY-MM-DD" no fuso de quem está usando.
 * Mantido como reexport para não quebrar os pontos de uso existentes —
 * a implementação única vive em utils/datetime.js.
 */
export function getLocalDateISO() {
  return todayISO();
}
